import ApiManager from '@/utils/ApiManager'
import Constants from '@/utils/Constants'
import Utility from '@/utils/Utility'
import Vue from 'vue'

const state = {
  categoryName: '配信タイプ',

  // model
  deliveryTypeMstModel: [],
  // 202305 配信先設定 追加 ST
  deviceModel: [],
  // 202305 配信先設定 追加 ED

  // form
  targetId: Constants.RegisterHash,
  values: {}
}

const getters = {
  get: state => state,

  // form mode
  isRegister: state => state.targetId === Constants.RegisterHash,
  isModify: state => state.targetId !== Constants.RegisterHash,

  // 登録値を表示用に変換
  getValue: state => (key) => {
    try {
      let value = state.values[key]
      switch (key) {
        default:
          return value
      }
    /* eslint-disable no-new */
    } catch (e) {
      return ''
    }
  }
}

const actions = {
  // 202305 配信先設定 追加 ST
  /**
   * 初期データを読出し
   */
  loadModel ({commit}, {deliveryTypeMstParams}) {
    return new Promise((resolve, reject) => {

      const types = ['deliveryTypeMst','device']
      const methods = ['v1DeliveryTypeMstListGet','v1DeviceListGet']
      const parameters = [deliveryTypeMstParams,[]]

      ApiManager.request(types,methods,parameters)
        .then(res => {
          let status = Utility.parseResponse(res)

          if (status.result) {
            commit('setDeliveryTypeMstModel', res[0].data.deliveryTypeMsts)
            commit('setDeviceModel', res[1].data.deviceTypes)
            console.log('deliveryTypeMstModel', state.deliveryTypeMstModel)
            console.log('deviceModel', state.deviceModel)
            resolve()

          } else if (status.error) {
            // エラーメッセージ表示
            reject(res)
          } else {
            // アプリケーションエラー表示
            reject(null)
          }
        })
        .catch(error => {
          // アプリケーションエラー表示
          reject(null)
        })
    })
  },
  // 202305 配信先設定 追加 ED
  /**
   * フォームの初期化
   */
  initRegister ({commit}) {
    commit('setTargetId', Constants.RegisterHash)
    commit('initRegister')
  },
  initModify ({commit}, {data}) {
    commit('setTargetId', data.DeliveryTypeMstId)
    commit('initModify', data)
  },

  /**
   * リセット
   */
  reset ({commit}) {
    commit('reset')
  }
}

const mutations = {
  // model
  setDeliveryTypeMstModel (state, data) {
    Vue.set(state, 'deliveryTypeMstModel', data)
  },
  // 202305 配信先設定 追加 ST
  setDeviceModel(state, data) {
    Vue.set(state, 'deviceModel', data)
  },
  // 202305 配信先設定 追加 ED

  // form
  setTargetId (state, targetId) {
    state.targetId = targetId
  },
  setValues (state, values) {
    Vue.set(state, 'values', values)
  },
  setInputValue (state, {key, value}) {
    Vue.set(state.values, key, value)
  },

  // form mode
  initRegister (state) {
    Vue.set(state.values, 'inpDeliveryTypeName', null)
    Vue.set(state.values, 'inpDeliveryType', null)
    Vue.set(state.values, 'inpDeliveryPriorityKbn', '')
    Vue.set(state.values, 'inpCmsDisplayKbn', '')
    Vue.set(state.values, 'inpLedDisplayKbn', '')
    Vue.set(state.values, 'inpLedInterval', '')
    Vue.set(state.values, 'inpDeliveryConfig', '')
    // 202305 配信先設定 追加 ST
    Vue.set(state.values, 'inpTargetDeviceTypeUuids', [])
    Vue.set(state.values, 'inpIsFavoritesVisibleOnSPApp', false)
    // 202305 配信先設定 追加 ED
    Vue.set(state.values, 'inpNoticeTypes', [])
    Vue.set(state.values, 'inpStatus', '')
  },
  initModify (state, data) {
    Vue.set(state, 'values', data)
    Vue.set(state.values, 'inpDeliveryTypeName', data.deliveryTypeName)
    Vue.set(state.values, 'inpDeliveryType', data.deliveryType)
    Vue.set(state.values, 'inpDeliveryPriorityKbn', data.deliveryPriorityKbn)
    Vue.set(state.values, 'inpCmsDisplayKbn', data.cmsDisplayKbn)
    Vue.set(state.values, 'inpLedDisplayKbn', data.ledDisplayKbn)
    Vue.set(state.values, 'inpLedInterval', data.ledOnInterval || '')
    Vue.set(state.values, 'inpDeliveryConfig', data.deliveryConfigFlg)
    // 202305 配信先設定 追加 ST
    Vue.set(state.values, 'inpTargetDeviceTypeUuids', data.targetDeviceTypeUuids)
    Vue.set(state.values, 'inpIsFavoritesVisibleOnSPApp', data.isTargetSpApp)
    // 202305 配信先設定 追加 ED
    let noticeTypeIds = data.linkedNoticeTypes.map(item => item.noticeTypeMstUuid)
    Vue.set(state.values, 'inpNoticeTypes', noticeTypeIds || [])
    Vue.set(state.values, 'inpStatus', data.deliveryTypeStatus)
  },

  // reset
  reset (state) {
    state.targetId = Constants.RegisterHash
    Vue.set(state, 'values', {})
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
